
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Link from "next/link";
import MainButton from "../../../common/MainButton";
const Banner = ({ banner }) => {
    return (<section className={'banner'}>
            <div className="container">
                {banner.label && <span className={'banner_label'}>{banner.label}</span>}
                <div className="banner_wrapper">
                    <h1 className={'banner_title'}>{banner.title}</h1>
                    <div className={'banner_description'}>
                        <p className={'banner_description_text'}>{banner.text}</p>
                        <Link className={'banner_description_cta'} href={process.env.NEXT_PUBLIC_APP_URL}>
                            <MainButton title={banner.cta}/>
                        </Link>
                    </div>
                </div>
            </div>
        </section>);
};
export default Banner;

    async function __Next_Translate__getStaticProps__1976335963b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//about/Banner/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1976335963b__ as getStaticProps }
  